import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "antd";
import Dashboard from "./screens/dashboard";

function App() {
  const { Content } = Layout;

  return (
    <Layout>
      <Layout>
        <Content>
          <Routes>
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

export default App;
